export const GET_ALL_SUBMISSIONS = 'GET_ALL_SUBMISSIONS'
export const LOAD_SUBMISSIONS = 'LOAD_SUBMISSIONS'
export const SUBMIT_GRADE = 'SUBMIT_GRADE'
